module.exports = __webpack_public_path__ + "static/media/welcome.6c9839a9.svg";